document.addEventListener("tpo_loaded", function () {
    console.log("test1");
    //添加选项说明
    var color_help =
      '<span class="product_color_help">' +
      '<a href="/pages/color-chart">色見本</a>' +
      '<a href="/pages/help-measure">採寸方法</a>' +
      "</span>";
    var size_help =
      '<span class="product_size_help">' +
      '<a class="size-chart-up" href="javascript:">サイズチャート</a>' +
      '<a href="/pages/customize">オーダーについて</a>' +
      "</span>";
  
    var setplan_help =
      '<a class="setplan_help"  href="javascript:">セットプラン？</a>';
  
    var sizeDrop_help = '<div class="showsizes"></div>';
  
    $("span.form__label")
      .filter(function () {
        return $(this).text().trim() === "カラーを選択してください";
      })
      .each(function () {
        $(this).parent().append(color_help);
      });
    $("span.form__label")
      .filter(function () {
        return $(this).text().trim() === "サイズ";
      })
      .each(function () {
        $(this).parent().append(size_help);
      });
  
    $("span.tpo_option_type_label")
      .filter(function () {
        return $(this).text().trim().includes("小物セットプラン");
      })
      .each(function () {
        $(this).append(setplan_help);
      });
    $("span.form__label")
      .filter(function () {
        return $(this).text().trim() === "サイズを選択してください";
      })
      .each(function () {
        $(this).parent().parent().append(sizeDrop_help);
      });
  
    $(".setplan_help").click(function () {
      $("#setplan_popup").css("display", "flex");
    });
    //尺码弹窗
    $(".size-chart-up").click(function () {
      $(".size-modal").css("display", "block");
      $(".size-modal").children(".size-modal-dialog").animate(
        {
          top: "5%",
        },
        250
      );
    });
    $(".size-modal-close").click(function () {
      $(".size-modal").children(".size-modal-dialog").animate(
        {
          top: "-100%",
        },
        250
      );
      $(".size-modal").css("display", "none");
    });
  
    //添加下面尺码信息
    var sizechartjson = {
      "5号": {
        バスト: "79",
        ウェスト: "58",
        ヒップ: "84",
        肩幅: "35",
        上半身丈: "37.5",
        下半身丈: "97.5",
        総丈: "135",
        身長: "155",
        ヒールの高さ: "7",
      },
      "7号": {
        バスト: "82",
        ウェスト: "62",
        ヒップ: "88",
        肩幅: "36",
        上半身丈: "39",
        下半身丈: "101",
        総丈: "140",
        身長: "160",
        ヒールの高さ: "7",
      },
      "9号": {
        バスト: "86",
        ウェスト: "66",
        ヒップ: "92",
        肩幅: "37",
        上半身丈: "39",
        下半身丈: "101",
        総丈: "140",
        身長: "160",
        ヒールの高さ: "7",
      },
      "11号": {
        バスト: "90",
        ウェスト: "70",
        ヒップ: "96",
        肩幅: "38",
        上半身丈: "40.5",
        下半身丈: "104.5",
        総丈: "145",
        身長: "165",
        ヒールの高さ: "7",
      },
      "13号": {
        バスト: "94",
        ウェスト: "74",
        ヒップ: "100",
        肩幅: "39",
        上半身丈: "41.5",
        下半身丈: "108.5",
        総丈: "150",
        身長: "170",
        ヒールの高さ: "7",
      },
      "15号": {
        バスト: "98",
        ウェスト: "78",
        ヒップ: "104",
        肩幅: "40",
        上半身丈: "42.5",
        下半身丈: "107.5",
        総丈: "150",
        身長: "170",
        ヒールの高さ: "7",
      },
    };
    $(".tpo_shape_circle").click(function () {
      if ($(this).hasClass("tpo_is_checked_buttons")) {
        var selectedValue = $(this).find(".tpo_buttons-input").attr("value");
        if (sizechartjson[selectedValue]) {
          var sizeData = sizechartjson[selectedValue];
          var table = "<table><tr><th>サイズ</th><th>値(cm)</th></tr>";
          $.each(sizeData, function (key, value) {
            table += "<tr><td>" + key + "</td><td>" + value + "</td></tr>";
          });
          table += "</table>";
          $(".showsizes").html(table);
        } else {
          $(".showsizes").html(
            "<p>製作できるサイズ：5号～15号とオーダーサイズ。標準サイズをご注文いただく場合、ご身長と当日履くヒールの高さより着丈を調整可能です。ご注文の際、ご希望をコメント欄にご記入ください。</p>"
          );
        }
      } else {
        $(".showsizes").html(
          "<p>製作できるサイズ：5号～15号とオーダーサイズ。標準サイズをご注文いただく場合、ご身長と当日履くヒールの高さより着丈を調整可能です。ご注文の際、ご希望をコメント欄にご記入ください。</p>"
        );
        return; // 退出点击事件处理程序
      }
    });
  });
  